/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PeaceIconConfig = {
  name: 'PeaceIcon',
  height: 512,
  width: 496,
  svgPath: 'M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PeaceIconConfig);
//# sourceMappingURL=peace-icon.js.map